import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { PROTECTED_API_URL } from '@lib/core/tokens/api.tokens';

import { HealthStatusCheck, HealthStatusCheckRequestBody } from '../models/health-status-check.interface';

@Injectable({
  providedIn: 'root',
})
export class HealthStatusChecksService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl: string;

  constructor(@Inject(PROTECTED_API_URL) apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  list(userId: string): Observable<HealthStatusCheck[]> {
    return this.http.get<HealthStatusCheck[]>(`${this.apiUrl}/health-check-ins/by-user/${userId}`);
  }

  create(userId: string, body: HealthStatusCheckRequestBody): Observable<HealthStatusCheck> {
    return this.http.post<HealthStatusCheck>(`${this.apiUrl}/health-check-ins/by-user/${userId}`, body);
  }

  cancel(userId: string, checkInId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/health-check-ins/by-user/${userId}/${checkInId}`);
  }
}
